import React from 'react'
import LogsStudents from './Logs'
import LcsData from './LcsData'
import Students from './Students'

const Marking = () => {

  return (
    <>
      <Students />
      <LogsStudents />
      <LcsData />
    </>
  )
}

export default Marking